import { useEffect, useState } from "react";
import { Alert, Button, Container } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";

import { IShipmentMaterialSearchRequest, IShipmentMaterialSearchResult } from "../../../types/shipment";

import { useUserContext } from "../../../contexts/userContext";

import { ShipmentService } from "../../../services/shipmentService";

import Navigation from "../../../components/header";
import Spinner from "../../spinner";
import PermissionGate from "../../permissionGate";
import ShippedMaterialTable from "../../tables/shippedMaterialTable";

import "../../../styles/shippedMaterials.scss";
import { AppConfig } from "../../../config/appConfig";


const ShippedMaterials = () => {
	const userContext = useUserContext();
	const [searchResults, setSearchResults] = useState<IShipmentMaterialSearchResult>();
	const [isLoadingMaterials, setIsLoadingMaterials] = useState(false);
	const [errorMessage, setErrorMessage] = useState<string | undefined>();

	//Date range
	const today = new Date();

	const [endDate, setEndDate] = useState(new Date());
	const [startDate, setStartDate] = useState(new Date(today.setDate(today.getDate() - 30)));

	//Filtering
	// const [bolOptions, setBolOptions] = useState<string[]>([]);
	// const [customerOptions, setCustomerOptions] = useState<string[]>([]);
	// const [vendorOptions, setVendorOptions] = useState<string[]>([]);
	const [bolFilter, setBolFilter] = useState("All");
	const [customerFilter, setCustomerFilter] = useState("All");
	const [vendorFilter, setVendorFilter] = useState("All");

	useEffect(() => {
		loadMaterials();
	}, [])

	const loadMaterials = async () => {
		try {
			const initialSearchRequest: IShipmentMaterialSearchRequest = {
				pageIndex: 0,
				pageSize: AppConfig.shippingMaterialsDefaultPageSize,
			}
			await searchShippedMaterials(initialSearchRequest);
		}
		catch (error) {
			console.log('ShipmentService.searchShippedMaterials: ERROR', error);
		}	
	}

	const searchShippedMaterials = async (searchRequest: IShipmentMaterialSearchRequest) => {
		setErrorMessage(undefined);
		setIsLoadingMaterials(true);
		searchRequest.startDate = startDate;
		searchRequest.endDate = endDate;
		ShipmentService.searchShippedMaterials(searchRequest)
			.then((response) => {
				console.log('ShipmentService.searchShippedMaterials: SUCCESS', response);
				const results = response.data as IShipmentMaterialSearchResult;
				
				results.records = ShipmentService.mapShipmentMaterials(results.records);
				setSearchResults(results);
			})
			.catch((error) => {
				console.log('ShipmentService.searchShippedMaterials: ERROR', error);				
				if (error?.code == "ERR_NETWORK") {
					setErrorMessage(AppConfig.apiConnectionErrorMessage)
				}
			}).finally(() => {
				setIsLoadingMaterials(false);
			});
	};

	const criteriaUpdated = async (searchRequest: IShipmentMaterialSearchRequest) => {
		await searchShippedMaterials(searchRequest);
	};

	const handleStartDateChange = (value: Dayjs | null) => {
		if (value) {
			setStartDate(value.toDate());
		}
	}

	const handleEndDateChange = (value: Dayjs | null) => {
		if (value) {
			setEndDate(value.toDate());
		}
	}

    return (
        <div className="hwi-shipped-materials-list">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageShipments}>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<section className="search-bar">
							<div className="search-header">
								<div className="title">Shipped Materials</div>
								<div className="controls">
									<div className="date-field">
										<DatePicker className="start-date-field" label="Start" value={dayjs(startDate)} onChange={(value) => handleStartDateChange(value)} />
									</div>
									<div className="date-field">
										<DatePicker className="start-date-field" label="End" value={dayjs(endDate)} onChange={(value) => handleEndDateChange(value)} />
									</div>
									<div className="button">
										<Button variant="outlined" fullWidth={true} onClick={loadMaterials} >Search</Button>
									</div>
								</div>
							</div>
							<section className="search-options">
								{/* <FormControl size="small">
									<InputLabel>BOL#</InputLabel>
									<Select
										value={bolFilter}
										defaultValue="All"
										label="BOL#"
										onChange={(event: SelectChangeEvent) => { setBolFilter(event.target.value) }}
									>
										<MenuItem value="All" key="-1">All</MenuItem>
										{bolOptions.map((item, index) => (
											<MenuItem value={item} key={index}>{item}</MenuItem>
										))}
									</Select>
								</FormControl>
								<FormControl size="small">
									<InputLabel>Customer</InputLabel>
									<Select
										value={customerFilter}
										label="Customer"
										onChange={(event: SelectChangeEvent) => { setCustomerFilter(event.target.value) }}
									>
										<MenuItem value="All" key="-1">All</MenuItem>
										{customerOptions.map((item, index) => (
											<MenuItem value={item} key={index}>{item}</MenuItem>
										))}
									</Select>
								</FormControl>
								<FormControl size="small">
									<InputLabel>Vendor</InputLabel>
									<Select
										value={vendorFilter}
										label="Vendor"
										onChange={(event: SelectChangeEvent) => { setVendorFilter(event.target.value) }}
									>
										<MenuItem value="All" key="-1">All</MenuItem>
										{vendorOptions.map((item, index) => (
											<MenuItem value={item} key={index}>{item}</MenuItem>
										))}
									</Select>
								</FormControl>
								<FormControl size="small">
									<InputLabel>Status</InputLabel>
									<Select
										value={statusFilter}
										label="Status"
										onChange={(event: SelectChangeEvent) => { setStatusFilter(event.target.value) }}
									>
										<MenuItem value="All" key="-1">All</MenuItem>
										{statusOptions.map((item, index) => (
											<MenuItem value={item} key={index}>{item}</MenuItem>
										))}
									</Select>
								</FormControl> */}
							</section>
						</section>
						<section className="results">
							{errorMessage &&
								<Alert className="alert-error"
									severity="error">
									{errorMessage}
								</Alert>
							}
							{!errorMessage &&
								<ShippedMaterialTable data={searchResults} bol={bolFilter} customer={customerFilter} vendor={vendorFilter} isAwaitingResultSet={isLoadingMaterials} update={criteriaUpdated}></ShippedMaterialTable>
							}	
						</section>
						{/* <Json data={gridView}></Json> */}
					</LocalizationProvider>
				</PermissionGate>
			</Container>
		</div>
    );
};

export default ShippedMaterials;
